import { instance as axios, setJwtToken, setMultiPartHeader } from "../../config/AxiosInstance"

// ---------------------upload-attachment----------------------------------
export const uploadAttachmentApi = async (data) => {
  const endPoint = `public/upload`
  return await axios.post(endPoint, data, setMultiPartHeader());
};


